import React from 'react';
import Login from '../pages/auth-pages/login';
import ResetPassword from '../pages/auth-pages/reset-password';
import User from 'app/pages/user';

import Page from '@jumbo/shared/Page';
import AddUser from 'app/pages/user/add-update-user';
import AddRole from 'app/pages/role/add-update-role';
import Role from 'app/pages/role';
import PrivateRoute from './PrivateRoute';
import Error404 from 'app/pages/pagenotfound';
import Home from 'app/pages/home/Home';
import Permissions from 'app/pages/role/permission';
import Error401 from 'app/pages/401';
import SetPassword from 'app/pages/auth-pages/set-password';
import ChangePassword from 'app/pages/auth-pages/change-password';
import Dictionary from 'app/pages/dictionary';

/**
 routes only accessible to authenticated users
 **/
 
const routesForAuthenticatedOnly = [
  {
    path: '/',
    element: (
      <PrivateRoute>
        <Page component={Home} />
      </PrivateRoute>
    ),
  },
  {
    path: '/manage-dictionary',
    element: (
      <PrivateRoute>
        <Page component={Dictionary} />
      </PrivateRoute>
    ),
  },
  {
    path: '/401',
    element: (
      <PrivateRoute>
        <Page component={Error401} />
      </PrivateRoute>
    ),
  },
  {
    path: '/users',
    element: (
      <PrivateRoute permission="user-list">
        <Page component={User} />
      </PrivateRoute>
    ),
  },
  {
    path: '/add-user',
    element: (
      <PrivateRoute permission="user-create">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: '/edit-user/:id',
    element: (
      <PrivateRoute permission="user-update">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },

  {
    path: '/roles',
    element: (
      <PrivateRoute permission="role-list">
        <Page component={Role} />
      </PrivateRoute>
    ),
  },
  {
    path: '/role/add_role',
    element: (
      <PrivateRoute permission="role-create">
        <Page component={AddRole} />
      </PrivateRoute>
    ),
  },
  {
    path: '/role/edit_role/:id',
    element: (
      <PrivateRoute permission="role-update">
        <Page component={AddRole} />
      </PrivateRoute>
    ),
  },
  {
    path: '/permission/:id',
    element: (
      <PrivateRoute permission="permission-manage">
        <Page component={Permissions} />
      </PrivateRoute>
    ),
  },
  {
    path: '/change-password',
    element: (
      <PrivateRoute>
        <Page component={ChangePassword} />
      </PrivateRoute>
    ),
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: '/login',
    element: <Page component={Login} layout={'solo-page'} />,
  },
  {
    path: '/reset-password',
    element: <Page component={ResetPassword} layout={'solo-page'} />,
  },
  {
    path: '/set-password',
    element: <Page component={SetPassword} layout={'solo-page'} />,
  },
  {
    path: '*',
    element: (
      <Page component={Error404} layout={'solo-page'} disableSmLogin={true} />
    ),
  },
];

const routes = [
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
